import type { AdIntelligenceController } from "../shared/types/types";

export const AD_INTEL_CTRL = "api/adIntelligence";

export const getAdvertiserPublisherEndpoint = (
    controller: AdIntelligenceController,
    resource: AdIntelligenceController,
) => `${AD_INTEL_CTRL}/${controller}/${resource}s/breakdown`;

export const getAdvertiserPublisherCompareEndpoint = (
    controller: AdIntelligenceController,
    resource: AdIntelligenceController,
) => `${AD_INTEL_CTRL}/${controller}/${resource}s/compare-mode`;

export const getAdvertiserPublisherExcelEndpoint = (
    controller: AdIntelligenceController,
    resource: AdIntelligenceController,
) => `/${AD_INTEL_CTRL}/${controller}/${resource}s/excel`;

export const getAdvertiserPublisherCompareExcelEndpoint = (
    controller: AdIntelligenceController,
    resource: AdIntelligenceController,
) => `/${AD_INTEL_CTRL}/${controller}/${resource}s/compare-mode/excel`;
